module.exports = __webpack_public_path__ + "static_pc/img/ba07.bce25ede.png";